import $ from 'domtastic';
import axios from 'axios';
import feedItems from './markup/feedItems';

class FeedData {
  static get() {
    const feedIds = window.feedIds.split(',');
    const config = {
      params: { feedIds },
    };

    return new Promise((resolve, reject) => {
      axios.get('/wp-json/app/v1/facebook', config)
        .then(response => FeedData.create(response.data))
        .then(data => resolve(data))
        .catch(err => reject(err));
    });
  }

  static create(feedObjects) {
    const itemsMarkup = feedItems.create(feedObjects);
    const $items = $(itemsMarkup);

    const itemsMarkupMobile = feedItems.createMobile(feedObjects);
    const $itemsMobile = $(itemsMarkupMobile);

    return [$items, $itemsMobile];
  }
}

export default FeedData;



// WEBPACK FOOTER //
// ./components/FeedData.js